export enum GameModeType {
    None = -1,
    Normal = 0,
    Timed,
    Survival,
    Tutorial,
    Easy,
    Zen,
    Quickplay,
    Fungus,
    Cupcake,
}
